<template>
    <button class="btn btn-primary btn-icon scroll-top mb-1" type="button">
        <i data-feather="arrow-up"></i>
    </button>
    <footer class="footer footer-light">
        <p class="clearfix mb-0 text-center">
            <span class="float-left d-block d-md-inline-block mt-25"> COPYRIGHT ©
                {{ year }}
                <a class="ms-25" href="" target="_blank">Creditfixrr&trade;</a>
                <span class="d-none d-sm-inline-block">All Rights Reserved</span>
            </span>
            <span class="d-none d-sm-inline-block">
                <a class="text-bold-400 grey darken-2" style="display: inline-block"
                    :href="routes.termsUrl">Terms Of Use </a> |
                <a class="text-bold-400 grey darken-2" style="display: inline-block"
                    :href="routes.privacyPolicyUrl" target="_blank">Privacy Policy</a>
            </span>
            <span class="float-right d-none d-md-block">
                Made with <i data-feather="heart"></i> KdotMdot Developments
            </span>
        </p>
    </footer>
</template>

<script>
    import { reactive, ref, computed } from 'vue'
    export default {
        props: {
            routes: {
                type: [Array, Object]
            }
        },
        mounted() {
        },
        setup() {
            const year = ref(new Date().getFullYear());
            return {
                year
            }
        },
    }
</script>
